import { CostCenter } from 'models/costCenter';

import { Reset } from './generic';

export const LOAD_COST_CENTER_LIST = 'LOAD_COST_CENTER_LIST';
export const UPDATE_COST_CENTER = 'UPDATE_COST_CENTER';
export const LOAD_COST_CENTER_REQUEST = 'LOAD_COST_CENTER_REQUEST';
export const DELETE_COST_CENTER = 'DELETE_COST_CENTER';
export const CREATE_COST_CENTER = 'CREATE_COST_CENTER';

export interface LoadCostCenterRequest {
  type: typeof LOAD_COST_CENTER_REQUEST;
}

export interface LoadCostCenterData {
  type: typeof LOAD_COST_CENTER_LIST;
  costCenterList: CostCenter[];
}

export interface UpdateCostCenterCode {
  type: typeof UPDATE_COST_CENTER;
  costCenter: CostCenter;
}

export interface DeleteCostCenter {
  type: typeof DELETE_COST_CENTER;
  costCenter: CostCenter;
}

export interface CreateCostCenter {
  type: typeof CREATE_COST_CENTER;
  costCenter: CostCenter;
}

export type CostCenterActions =
  | LoadCostCenterData
  | UpdateCostCenterCode
  | DeleteCostCenter
  | CreateCostCenter
  | LoadCostCenterRequest
  | Reset;

export const doLoadCostCenterRequest = () => ({ type: LOAD_COST_CENTER_REQUEST });

export const doLoadCostCenterList = (costCenterList: CostCenter[]): CostCenterActions => ({
  type: LOAD_COST_CENTER_LIST,
  costCenterList,
});

export const doUpdateCostCenterCode = (costCenter: CostCenter): CostCenterActions => ({
  type: UPDATE_COST_CENTER,
  costCenter,
});

export const doDeleteCostCenter = (costCenter: CostCenter): CostCenterActions => ({
  type: DELETE_COST_CENTER,
  costCenter,
});

export const doCreateCostCenter = (costCenter: CostCenter): CostCenterActions => ({
  type: CREATE_COST_CENTER,
  costCenter,
});
